import { render, staticRenderFns } from "./receber-parcela-lote.vue?vue&type=template&id=bee39fdc&scoped=true&"
import script from "./receber-parcela-lote.vue?vue&type=script&lang=js&"
export * from "./receber-parcela-lote.vue?vue&type=script&lang=js&"
import style0 from "./receber-parcela-lote.vue?vue&type=style&index=0&id=bee39fdc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bee39fdc",
  null
  
)

export default component.exports